import { render, staticRenderFns } from "./PaymentDetail.pug?vue&type=template&id=5fe8f867&scoped=true&lang=pug&"
import script from "./PaymentDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetail.scss?vue&type=style&index=0&id=5fe8f867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8f867",
  null
  
)

export default component.exports